function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.95 6.96a.547.547 0 010 .774l-3.67 3.67a.547.547 0 01-.773 0L5.761 9.655a.547.547 0 11.773-.773l1.36 1.36 3.282-3.282a.547.547 0 01.774 0z",
  fill: "#54585D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.948 2.693L9.58 4.324a.468.468 0 10.661-.662l-.87-.87a6.477 6.477 0 013.848 1.863 6.553 6.553 0 11-6.527-1.637l-.269-.896a7.485 7.485 0 107.457 1.871 7.405 7.405 0 00-4.477-2.14l.838-.837A.468.468 0 009.58.354L7.948 1.986a.5.5 0 000 .707z",
  fill: "#54585D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h17v17H0z"
}))));